import styled from 'styled-components';
import { Img } from 'react-image';
import color from '../../constants/color';
import materialUI from '../../material-UI';

export const Card = styled(materialUI.Card)`
  display: flex;
  flex-direction: column;
  max-width: 290px;
  min-width: 290px;
  margin: 30px 0px 30px 0px;
`;
export const CardAction = styled.div``;
export const CardImages = styled(Img)`
  width: ${(props) => (props.style?.width ? props.style.width : '100%')};
  height: ${(props) => (props.style?.height ? props.style.height : '188px')};
`;
export const CardContent = styled(materialUI.CardContent)``;
export const CardImage = styled.div`
  display: flex;
  flex-direction: column;
`;
export const OnPress = styled(materialUI.IconButton)``;
export const CardBody = styled.div`
  display: flex;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: Row;
  padding: 16px 10px 0px 10px;
`;
export const Icon: any = styled.img`
`;
export const TitleCard = styled.div`
  font-family: Inter;
  color: ${color.grey10};
  font-size: 1.2em;
`;
export const SubTitleCard = styled.div`
  font-family: Inter;
  color: ${color.grey10};
  font-size: 0.85em;
  margin-left: 10px;
`;
export const Space = styled.div`
  height: 5px;
`;
